import React, { useState } from "react";
import { api } from "./axiosInstance";

const UpdatePassword = ({ onComplete, onSkip, isHardBlock }) => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (newPassword !== confirmPassword) {
            setError("New passwords do not match.");
            return;
        }

        if (newPassword.length < 12) {
            setError("Password must be at least 12 characters. Tips for choosing a strong password: https://xkcd.com/936");
            return;
        }

        try {
            await api.post("/auth/update-password", { currentPassword, newPassword });
            setSuccess(true);
            setTimeout(() => { if (onComplete) onComplete(); }, 1500);
        } catch (err) {
            setError(err.response?.data?.error || "Failed to update password.");
        }
    };

    if (success) {
        return (
            <div className="text-center">
                <p className="text-green-400 font-bold">Password updated successfully!</p>
            </div>
        );
    }

    return (
        <div className="text-center">
            <h2 className="text-xl font-bold text-orange mb-4">
                {isHardBlock ? "Password Update Required" : "Update Your Password"}
            </h2>
            <p className="text-sm text-gray-300 mb-4">
                {isHardBlock
                    ? "Your password no longer meets security requirements. You must update it to continue."
                    : (
                        <>
                            Your current password doesn't meet our updated security requirements.
                            Please create a new password with at least 12 characters.
                        </>
                    )
                }
                <br />
                <a href="https://xkcd.com/936" target="_blank" rel="noopener noreferrer" className="text-lightblue hover:text-white underline">
                    Tips for strong passwords
                </a>
            </p>

            {error && <div className="bg-red text-white text-sm p-2 rounded mb-4">{error}</div>}

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium mb-1 text-left">Current Password</label>
                    <input
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                        className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:ring-orange"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1 text-left">New Password (12+ characters)</label>
                    <input
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        minLength={12}
                        className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:ring-orange"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium mb-1 text-left">Confirm New Password</label>
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        className="w-full px-3 py-2 rounded bg-deepblue text-lightgray border border-lightblue focus:ring-orange"
                    />
                </div>
                <button type="submit" className="w-full py-2 px-4 bg-orange text-white font-medium rounded hover:bg-deeporange">
                    Update Password
                </button>
            </form>

            {onSkip && (
                <button
                    onClick={onSkip}
                    className="w-full text-sm text-lightblue hover:text-white mt-3"
                >
                    Remind me later
                </button>
            )}
        </div>
    );
};

export default UpdatePassword;
